// extracted by mini-css-extract-plugin
export default {"triggerWrapper":"popupOnClick__triggerWrapper-sCrnP"};